// src/components/ride/BookingSuccess.jsx

import React from "react";
import { CheckCircle2, Phone, MessageCircle, ArrowRight } from "lucide-react";

const BookingSuccess = ({ onClose }) => {
  return (
    <div className="animate-[fadeIn_.35s_ease-out] py-6 text-center">
      {/* Icon */}
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-[#00A260]/10">
        <div className="flex h-11 w-11 items-center justify-center rounded-full bg-[#00A260] text-white">
          <CheckCircle2 className="h-6 w-6" />
        </div>
      </div>

      {/* Heading */}
      <h3 className="mt-5 text-xl font-extrabold text-[#061A3A]">
        Ride Request Received
      </h3>

      <p className="mx-auto mt-2 max-w-md text-sm leading-6 text-[#64748B]">
        Thank you! Our NJV Travels team has received your ride request and
        will contact you shortly to confirm the vehicle and travel details.
      </p>

      {/* Info card */}
      <div className="mx-auto mt-6 max-w-sm rounded-2xl border border-[#E2E8E5] bg-[#FAFCFB] p-4 text-left">
        <p className="mb-3 text-[10px] font-bold uppercase tracking-wider text-[#64748B]">
          What happens next
        </p>

        <div className="space-y-3">
          <div className="flex items-start gap-2.5">
            <Phone className="mt-0.5 h-4 w-4 shrink-0 text-[#00A260]" />
            <p className="text-xs leading-5 text-[#061A3A]">
              Our team will call you to confirm your booking.
            </p>
          </div>

          <div className="flex items-start gap-2.5">
            <MessageCircle className="mt-0.5 h-4 w-4 shrink-0 text-[#00A260]" />
            <p className="text-xs leading-5 text-[#061A3A]">
              You'll receive a WhatsApp message with the vehicle details.
            </p>
          </div>
        </div>
      </div>

      {/* CTA */}
      <button
        type="button"
        onClick={onClose}
        className="mt-6 inline-flex h-11 items-center justify-center gap-2 rounded-xl bg-[#00A260] px-6 text-sm font-bold text-white transition hover:bg-[#005543]"
      >
        Done
        <ArrowRight className="h-4 w-4" />
      </button>
    </div>
  );
};

export default BookingSuccess;